// Faixa do anuncio no Mercado Livre na ficha do produto (so em canal ML): estado, motivo e link.
// Os campos do canal (titulo, genero, embalagem...) aparecem na ficha pelo field_schema do canal,
// como em qualquer canal; aqui entra so o que e do ML.
import { ExternalLink } from "lucide-react";
import { describeMlItem, type ProductMl } from "../../lib/ml-channel";
import { StatusDot } from "../ui/StatusDot";

const DOT = { ok: "good", warn: "warn", bad: "bad", idle: "neutral" } as const;

export function MlItemStrip({ ml }: { ml: ProductMl | null | undefined }): JSX.Element | null {
  const view = describeMlItem(ml ?? null);
  if (!view || !ml) return null;
  return (
    <div
      className="cluster"
      role="status"
      style={{
        marginBottom: ".75rem",
        padding: ".5rem .75rem",
        borderRadius: "var(--radius-md)",
        background: "var(--color-soft)",
        border: ".0625rem solid var(--color-line)",
        fontSize: "var(--text-sm)",
      }}
    >
      <StatusDot tone={DOT[view.tone]} />
      {/* Titulo e detalhe no MESMO texto corrido: o separador gruda no detalhe (espaco inseparavel depois dele), entao nunca sobra "·" no fim da linha quando quebra. */}
      <span style={{ minWidth: 0, overflowWrap: "anywhere" }}>
        <span style={{ fontWeight: 800 }}>{view.title}</span>
        <span className="field__hint mono">
          {" "}
          <span aria-hidden style={{ color: "var(--color-ink-3)" }}>·</span>
          {" "}
          {view.detail}
        </span>
      </span>
      {ml.permalink ? (
        <a
          href={ml.permalink}
          target="_blank"
          rel="noreferrer"
          className="text-coral underline underline-offset-2 hover:no-underline"
          style={{ marginLeft: "auto" }}
        >
          Ver no Mercado Livre <ExternalLink className="icon" style={{ width: "0.875em", height: "0.875em", display: "inline", verticalAlign: "-0.1em" }} aria-hidden />
        </a>
      ) : null}
    </div>
  );
}
